import styled, { keyframes } from 'styled-components';
import React from 'react'
import Menu from '../../components/Menu/Navbar'
import Header from '../../components/Header/header'
import Logo from '../../components/Logo/logo'
import Footer from '../../components/Footer/footer'

import BannerMontequinto from '../../components/Montequinto/BannerMontequinto/bannermontequinto'
import TextoMontequinto from '../../components/Montequinto/TextoMontequinto/textomontequinto'
import Carrusel from '../../components/Montequinto/Carrusel/carruselmontequinto'
import Contacto from '../../components/Montequinto/Contacto/Contacto'

import Informacion from '../../components/Montequinto/Informacion/informacion'






import PatrocinadoresBellavista from '../../components/Bellavista/PatrocinadoresBellavista/patrocinadores'
import FooterMontequinto from '../../components/Montequinto/FooterMontequinto/footermontequinto'


// Crear una animación de fade-in
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
export const ContainerGeneral = styled.div`

  // Aplicar la animación de fade-in aquí
  animation: ${fadeIn} 2s ease-in-out;
  animation-fill-mode: forwards; // Asegurar que el elemento se mantenga en el estado final
  opacity: 0; // Inicializar en opacidad 0
`;





const Montequinto = () => {
    return (
        <div>
            <Menu />
            <Header />
            <Logo />

            <ContainerGeneral>
                <BannerMontequinto />
                <TextoMontequinto />
                <Carrusel />
                 <Contacto />

 <Informacion />


   <FooterMontequinto />
                <PatrocinadoresBellavista />
            </ContainerGeneral>
            <Footer />
            <></>
        </div>
    )
}

export default Montequinto
